import React from "react";

/**
 * PhotoBackdrop
 * A subtle industrial photo layer with a dark gradient overlay + the same
 * hero-grid pattern used elsewhere on the site. Designed to sit inside a
 * `position: relative; overflow: hidden` section.
 *
 * Props:
 *  - src          image path (from /public)
 *  - position     background-position (default "center 30%")
 *  - dim          gradient opacity multiplier — higher = darker (default 1)
 *  - grid         whether to overlay the hero-grid pattern (default true)
 */
const PhotoBackdrop = ({
  src,
  position = "center 30%",
  dim = 1,
  grid = true,
}) => {
  // 0.92 base opacity — bumped/reduced by `dim`
  const clamp = (v) => Math.max(0, Math.min(1, v));
  const top = clamp(0.92 * dim);
  const mid = clamp(0.78 * dim);
  const bot = clamp(0.96 * dim);

  return (
    <>
      <div
        className="absolute inset-0"
        aria-hidden="true"
        style={{
          backgroundImage: `url('${src}')`,
          backgroundSize: "cover",
          backgroundPosition: position,
        }}
      />
      <div
        className={`absolute inset-0 ${grid ? "hero-grid" : ""}`}
        aria-hidden="true"
        style={{
          background: `linear-gradient(180deg, rgba(6, 11, 24, ${top}) 0%, rgba(6, 11, 24, ${mid}) 55%, rgba(6, 11, 24, ${bot}) 100%)`,
        }}
      />
    </>
  );
};

export default PhotoBackdrop;
